import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import axios from 'axios';
import cacheLocation from './cacheLocation';
import notifyNewrelic from './notifyNewrelic';

const onError = shouldLogNewrelic => {
  const message = 'Error occured while calling secondary location API';
  notifyNewrelic(shouldLogNewrelic, 'Error', 'Eleanor_Api', message);
  const positionEvent = new CustomEvent('location', {
    detail: {
      success: false,
      message
    }
  });
  document.dispatchEvent(positionEvent);
  return {
    success: false,
    message
  };
};

const getLocationFromApi = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (url, cacheDuration, shouldLogNewrelic) {
    return axios.get(url).then(response => {
      if (response && response.status === 200) {
        const _response$data = response.data,
              ZipCodes = _response$data.ZipCodes,
              City = _response$data.City,
              State = _response$data.State,
              Country = _response$data.Country;
        const locationResult = {
          location: {
            zipCodes: ZipCodes,
            cities: [City],
            state: State,
            country: Country
          },
          success: true
        };
        cacheLocation(locationResult.location, cacheDuration);
        notifyNewrelic(shouldLogNewrelic, 'Success', 'Eleanor_Api', 'Location data recieved from secondary api');
        document.dispatchEvent(new CustomEvent('location', {
          detail: locationResult
        }));
        return locationResult;
      }

      return onError(shouldLogNewrelic);
    }).catch(() => onError(shouldLogNewrelic));
  });

  return function getLocationFromApi(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export default getLocationFromApi;